// extracted by mini-css-extract-plugin
export default {"Gallery":"Gallery_Gallery__LufLz","nav":"Gallery_nav__8zS9z","navList":"Gallery_navList__TAd-N","navLink":"Gallery_navLink__vDx43","navLinkInner":"Gallery_navLinkInner__sNh4N"};